module.exports = __webpack_public_path__ + "img/611.3c73f433.jpg";